<div class="video">
    <video controls (click)="toggleVideo()" #videoPlayer>
        <source src="{{videoUrl()}}" type="video/mp4"/>
        {{'Browser not supported' | translate}}
    </video>
</div>
